// const player = document.querySelector(".KD_cart_progress_checkmark");
// player.load("https://cdn.shopify.com/s/files/1/0741/8996/3571/files/Animation_-_1709712761018.json?v=1709713283");

const log = window.log;

$(document).on("mouseover", ".KD_cart_item_remove", function () {
  $(this).addClass('active');
});
$(document).on("mouseleave", ".KD_cart_item_remove", function () {
  $(this).removeClass('active');
});

function postToCart(items, successCallback) {
  $.post("/cart/add.js", { items }, successCallback)
    .fail(() => alert("Error adding items to the cart."));
}



$(document).on("click", ".KD_cart_sub_upsell", function () {
  $(this).addClass('active');
  $('.KD_cart_sub_headline').html('Upgrading...');

  var variant1 = 44836507189425; // Variant ID 1 (to be removed)
  var variant2 = 42855263502513; // Variant ID 2 (to be added with selling plan)
  var selling_plan = 1313734833; // Selling plan ID for variant2

  // Remove variant1 and add variant2 with selling plan
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: { updates: { [variant1]: 0 } },
    success: function () {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variant2, quantity: 1, selling_plan: selling_plan },
        dataType: 'json',
        success: function () { buildCart(); },
        error: function () { resetCartState(); }
      });
    },
    error: function () { resetCartState(); }
  });

  // Reset cart state on error
  function resetCartState() {
    $('.KD_cart_sub_headline').html('Something went wrong, please try again.');
    $(this).removeClass('active');
  }
});


function buildCart() {
  setTimeout(() => {
    const cart_item = [];
    const summary_item = [];
    jQuery.getJSON("/cart.js", cart => {
      log.collapse(cart, "Cart Data", "success");

      const ENABLE_UPGRADE_TO_SUBSCRIPTION = true;

      const currency = $('.KD_cart_checkout_btn').attr('data-cur').replace('0,00', '').replace('0.00', '');
      let compare_price_integer = 0, kamstukai = 0, dovana = 0, list300 = 0, upsellQty = 0;
      const list300id = 9196256428355, kamstukaiId = 'kamstukai', kamstukaiId2 = 'miegui', dovanaId = 'dovana', upsellId = 47268422779203;
      const excludedProductIds = [9857264943393, 8118752018721];

      // Filter out the excluded product when counting items
      let filteredItemCount = 0;

      cart.items.forEach(item => {
        if (excludedProductIds.includes(item.product_id)) return; // Skip the excluded product

        filteredItemCount += item.quantity; // Add quantity for items that are not excluded

        if (String(item.handle).includes(kamstukaiId) || String(item.handle).includes(kamstukaiId2)) kamstukai += item.quantity;
        if (String(item.handle).includes(dovanaId)) dovana += item.quantity;
        if (item.product_id == list300id) list300 = 1;
        if (item.id == upsellId) upsellQty = 1;

        let price = (item.line_price / 100).toFixed(2);
        let compare_price = (item.original_line_price / 100).toFixed(2);
        if (item.selling_plan_allocation) {
          log.table({
            "Compare at Price": compare_price,
            "Selling Plan Allocation Compare": item.selling_plan_allocation.compare_at_price,
          }, "Selling Plan Allocation", "info");
          if (item.selling_plan_allocation.compare_at_price * item.quantity > parseFloat(compare_price) * 100) {
            compare_price = (item.selling_plan_allocation.compare_at_price * item.quantity / 100).toFixed(2)
          }
        }
        compare_price_integer += parseFloat(compare_price);

        let price_line = (compare_price !== price ? `${currency}${price} <s>${currency}${compare_price}</s> ` : `${currency}${price} `);
        log.table(item, "Item", "success");
        log.table({
          "Element": "Cart",
          "Final Price": item.final_price,
          "Original Price": item.original_price,
          "Compare Price": compare_price,
          "Compare Price Parsed": parseFloat(compare_price),
          "Price": price,
          "Price Parsed": parseFloat(price),
          "Saved Price": parseFloat(compare_price) - parseFloat(price),
          "Saved Percentage": (parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price),
          "Saved Percentage Rounded": Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price))
        }, "Price Details", "info");
        price_line += (item.final_price !== item.original_price ? `<span class="discount">${Math.round((parseFloat(compare_price) - parseFloat(price)) * 100 / parseFloat(compare_price))}% OFF</span>` : '');

        const variant_option1 = item.variant_options[0], variant_option2 = item.variant_options[1];
        const variant_selling_plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name.replace('Delivery Frequency', 'Every') : 'One Time Purchase';

        const cart_option1_line = variant_option1 && variant_option1 !== 'Default Title' ? `<p class="KD_cart_item_variant">${variant_option1}</p>` : '';
        const cart_option2_line = variant_option2 && variant_option2 !== 'Default Title' ? `<p class="KD_cart_item_variant"><span>${variant_option2}</span></p>` : '';
        const cart_selling_plan_line = variant_selling_plan ? `<p class="KD_cart_item_variant"><span>${variant_selling_plan}</span></p>` : '';
        const item_title = item.product_title.replace(' - garsą izoliuojantys ausų kamštukai', '');

        // Check if the item can be converted to a subscription
        let upgradePrompt = '';
        if (ENABLE_UPGRADE_TO_SUBSCRIPTION && !item.selling_plan_allocation) {
          let plans = window.product_selling_plans[item.product_id] || [];
          let plan = plans.find(g => g.selling_plans.some(p => p.name.includes("4 Week")));

          if (plan) {
            let planId = plan.selling_plans.find(p => p.name.includes("4")).id;
            log(`Adding Upgrade To Sub for: ${item.id}, SubPlanId: ${planId}`);

            const checkIconUrl = "https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Check_Icon_01f26807-a2bd-4637-a7c1-1500415b9130.png?v=1738853428";
            const points = ["Lock-In Current Price", "Pause Or Cancel Anytime", "Free Express Shipping"]
              .map(p => `<point><img src="${checkIconUrl}" width="20" height="20"><p>${p}</p></point>`).join("");

            upgradePrompt = `
              <flex-col class="KD_cart_item_upgrade_wrapper">
                <p class="KD_cart_item_upgrade_label">76% of our users choose subscription</p>
                <flex-row class="KD_cart_item_upgrade">
                  <button type="button" class="KD_cart_upgrade_btn" data-id="${item.id}" data-plan-id="${planId}"></button>
                  <p>Upgrade to Subscription & <strong>Save 10%</strong> per purchase!</p>
                </flex-row>
                <flex-row class="KD_cart_item_upgrade_points">${points}</flex-row>
              </flex-col>
            `;
          }
        }

        cart_item.push(`
          <div class="KD_cart_item" data-id="${item.id}">
            <div><img src="${item.image}&width=100"></div>
            <div>
              <p class="KD_cart_item_title">${item_title}</p>
              <div class="KD_cart_item_variants"><flex>${cart_option1_line}${cart_option2_line}</flex>${cart_selling_plan_line}</div>
              <div class="KD_cart_item_quantity_cont">
                <div class="KD_cart_quantity_minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg></div>
                <div class="KD_cart_quantity_value">${item.quantity}</div>
                <div class="KD_cart_quantity_plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg></div>
              </div>
            </div>
            <div>
              <p class="KD_cart_item_price">${price_line}</p>
              <div class="KD_cart_item_remove">
                <img src="https://cdn.shopify.com/s/files/1/0898/2501/8136/files/Untitled_design_7_1.png?v=1732272564"><span class="loader"></span>
              </div>
            </div>
          </div>
          ${upgradePrompt}
        `);
      });

      // Check if only the excluded product remains
      if (filteredItemCount === 0 && cart.items.length > 0) $.post("/cart/clear.js", function () { log('Cart cleared'); return buildCart(); }, "json");


      const cart_total = (cart.total_price / 100).toFixed(2);
      const youSave = (compare_price_integer - (cart.total_price / 100)).toFixed(2);

      if (cart.item_count === 0) {
        $('.KD_cart_empty').show();
        $('.KD_cart_units span, #CartCount').html('0');
        $('discount-progress-bar, cart-drawer-content, .KD_cart_progress, .KD_cart_footer, .cart-count-bubble, .KD_cart_reserved').hide();
      } else {
        $('.KD_cart_reserved, .cart-count-bubble, cart-drawer-content, .KD_cart_footer, .KD_cart_progress').show();
        $('discount-progress-bar').css('display', 'flex');
        $('.KD_cart_empty').hide();
        $(".cart-count-bubble span").text(filteredItemCount); // Use the filtered count here
        $('.KD_cart_drawer_content__js').html(cart_item);
        $('.KD_cart_units span, #CartCount').html(filteredItemCount);

        if (cart_total == compare_price_integer) {
          setTimeout(() => {
            $('.KD_cart_summary_line.KD_save').hide();
          }, 50);
        } else {
          setTimeout(() => {
            $('.KD_cart_summary_line.KD_save').css('display', 'flex');
            $('.KD_save_price').html(currency + youSave);
          }, 50);
        }

        // Shipping logic
        const shipping_cost = (cart_total > 3000) ? '0.00 €' : '0 €';
        $('.KD_cart_summary_line[data="shipping"] .KD_cart_summary_prices').html(`${shipping_cost}<s>0 €</s>`);
        const total_with_shipping = cart_total > 3000 ? cart_total : cart_total + 0;
        $('.KD_cart_summary_line.subtotal .KD_cart_summary_prices').html(`${currency}${cart_total} <s>${currency}${total_with_shipping}</s>`);
        $('.KD_cart_summary_line.KD_cart_total .KD_cart_summary_prices').html(`${currency}${cart_total} <s>${currency}${total_with_shipping}</s>`);
        $('.KD_cart_checkout_price').html(currency + cart_total);
      }

      if ($('discount-progress-bar').length) updateDiscountProgressBar(cart, currency);
      $('.KD_cart_upsells_carousel').slick('refresh');
      setTimeout(() => $('.KD_cart_upsells_out').addClass('active'), 300);
    });
  }, 1000);
}

buildCart();




// Handle Subscription Upgrade
$(document).on("click", ".KD_cart_upgrade_btn", function () {
  var $cartItem = $(this).closest('.KD_cart_item');
  $cartItem.addClass('loading');

  $.post("/cart/change.js", { id: $(this).data("id"), selling_plan: $(this).data("plan-id") }, () => { buildCart(); $('.KD_cart_item').removeClass('loading'); });
});

function updateCartQuantity(action, element) {
  var $cartItem = $(element).closest('.KD_cart_item');
  $cartItem.addClass('loading');

  var quantity = parseFloat($cartItem.find('.KD_cart_quantity_value').html());
  if (action === 'plus') quantity++;
  if (action === 'minus') quantity--;
  if (action === 'remove') quantity = 0;

  var data = {
    id: $cartItem.attr('data-id'),
    quantity: quantity,
  };
  log(data, '   data');

  $.post("/cart/change.js", data, function () {
    buildCart();
    setTimeout(function () {
      $('.KD_cart_item').removeClass('loading');
    }, 1500);
  }, "json");
}

$(document).on("click", ".KD_cart_quantity_plus", function () {
  updateCartQuantity('plus', this);
});
$(document).on("click", ".KD_cart_quantity_minus", function () {
  updateCartQuantity('minus', this);
});
$(document).on("click", ".KD_cart_item_remove", function () {
  updateCartQuantity('remove', this);
});




$(".Product_atc_button").click(function () {
  if ($(this).attr("data-stock") == "1") addClassicItem();
});

$(document).on("click", ".KD_main_checking", function () {
  $(this).toggleClass('disabled');
  $('.Slide_cart_summary').addClass('loading');
  setTimeout(function () {
    $('.Slide_cart_summary').removeClass('loading');
  }, 1500);
});

function initProtection() {
  const dataId = $('.KD_cart_shipping_prot').data('id');
  if (!dataId) return;

  $.getJSON("/cart.js", ({ items, item_count }) => {
    if (item_count > 0) {
      const dataQty = items.find(item => item.id == dataId)?.quantity || 0;
      const targetQty = $('.KD_main_checking').hasClass('disabled') ? 0 : 1;

      if (dataQty !== targetQty) {
        $.post('/cart/update.js', { updates: { [dataId]: targetQty } }, () => {
          log(`${targetQty ? 'Added' : 'Removed'} Shipping-Protection`);
          buildCart();
        }).fail(() => {
          console.error(`${targetQty ? 'Failed to add' : 'Failed to remove'} Shipping-Protection`);
        });
      }
    }
  });
}


function toggleSwitchDefault() {
  const position = $('.KD_cart_shipping_prot').attr('data-protection');
  if (position !== '1') {
    $('.KD_main_checking').addClass('disabled');
  }
}

function initIntervals() {
  toggleSwitchDefault();
  initProtection();
}
$(document).ready(function () {
  initIntervals();
  setInterval(initIntervals, 500);
});


$('.KD_cart_upsells_single .KD_cart_upsells_carousel').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Arrow_Left.png?v=1738787968'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Arrow_Right.png?v=1738787968'/></button>",
});
$('.KD_cart_upsells_inline .KD_cart_upsells_carousel').slick({
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Arrow_Left.png?v=1738787968'/></button>",
  nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0596/8419/2545/files/Cart_Arrow_Right.png?v=1738787968'/></button>",
});

$(document).on("click", ".KD_cart_atc_ox", function (evt) {
  evt.preventDefault();
  const currentId = $(this).data("id");

  postToCart([{ id: currentId, quantity: 1 }], buildCart);
});




function addClassicItem() {
  $(".Product_atc_button").text("Įdedama...");

  const currentDeliveryDate = $(".delivery-hidden").val();
  const currentQty = $(".quantity__input").val();
  const currentId = $(".product-variant-id").val();
  const currentTitle = $(".product-variant-id").data("title-main");
  const currentImage = $(".product-variant-id")
    .data("img")
    .replace("http://127.0.0.1:9292", "https://noreo-lt.myshopify.com")
    .replace("//noreo.lt", "https://noreo-lt.myshopify.com");
  const currentProductId = $(".product-variant-id").data("product-id");
  const currentUrl = window.location.href;

  const data_klaviyo = {
    ProductId: currentProductId,
    Name: currentTitle,
    ImageUrl: currentImage,
    items: { id: currentId, quantity: currentQty },
    URL: currentUrl,
  };

  postToCart([{ id: currentId, quantity: currentQty }], () => {
    buildCart();
    gtag("event", "Clicked ATC", {
      event_label: "Clicked ATC Button",
      event_value: "Added To Cart",
    });
    _learnq.push(["track", "Added to Cart", data_klaviyo]);

    setTimeout(() => $(".Product_atc_button").text("Įdėti į krepšelį"), 1000);
    $("body").addClass("Overflow_hidden overflow-hidden");
    $(".KD_cart_drawer_outer")
      .css("display", "flex")
      .addClass("active", 100);
  });
}



function cartUpsellsAndProgress(cart_total_int) {
  const FREE_SHIPPING_THRESHOLD = 7500;
  let amount_left = FREE_SHIPPING_THRESHOLD - cart_total_int;
  let percent = Math.min((cart_total_int * 100) / FREE_SHIPPING_THRESHOLD, 100);
  let message = cart_total_int < FREE_SHIPPING_THRESHOLD
    ? `Add products for $${(amount_left / 100).toFixed(2)} more and get a FREE SHIPPING!`
    : `You’ve unlocked <span>FREE shipping</span> on your order today!`;

  $('.KD_cart_progress p').html(message);
  $('.KD_cart_progress_inner').css('width', `${percent}%`);
  log(message);
}


$('.KD_cart_checkout_btn').click(() => window.location.href = '/checkout');

$('.Slide_cart_agree_line').click(function () {
  $(this).toggleClass('active');
});


const countDownDate = new Date(Date.now() + 15 * 60 * 1000); // 15-minute countdown
const updateTimer = setInterval(() => {
  const distance = countDownDate - new Date();
  if (distance <= 0) {
    clearInterval(updateTimer);
    $(".hours, .KD_cart_timer__min, .KD_cart_timer__sek").text('0');
    $('.KD_cart_timer p').text('Time is out!');
  } else {
    const [hours, minutes, seconds] = [
      Math.floor((distance / (1000 * 60 * 60)) % 24),
      Math.floor((distance / (1000 * 60)) % 60),
      Math.floor((distance / 1000) % 60),
    ];
    $(".hours").text(hours);
    $(".KD_cart_timer__min").text(minutes);
    $(".KD_cart_timer__sek").text(seconds);
  }
}, 1000);




function updateDiscountProgressBar(cart, currency) {
  const $progressBar = $(".discount-bar__progress-bar");
  const $progressFill = $(".discount-bar__progress-fill");
  const $statusMessageElement = $(".discount-bar__status");
  let totalPrice = 0;
  const thresholds = [];

  // Calculate total price from cart items
  cart.items.forEach(item => {
    if (item.requires_shipping || item.handle.includes("shipping-protection")) totalPrice += item.final_line_price;
  });

  const cartDiscount = cart.cart_level_discount_applications.reduce(
    (sum, discountAllocation) => sum + discountAllocation.total_allocated_amount,
    0
  );
  totalPrice -= cartDiscount;

  // Initialize thresholds from DOM
  $(".discount-bar__threshold").each(function () {
    thresholds.push({
      value: parseFloat($(this).data("value")),
      text: $(this).find(".discount-bar__threshold-text").text(),
      isDiscount: $(this).data("discount") === "true",
      element: $(this),
    });
  });

  let fillPercentage = 0;
  let freeShippingUnlocked = false;
  let highestDiscountUnlocked = null;
  let nextThreshold = null;
  const progressStep = 100 / thresholds.length;

  // Reset the 'filled' class for thresholds that should no longer be filled
  thresholds.forEach((threshold) => {
    threshold.element.removeClass("discount-bar__threshold--filled");
  });

  thresholds.forEach((threshold, index) => {
    const prevValue = thresholds[index - 1]?.value || 0;

    if (totalPrice >= threshold.value) {
      fillPercentage = (index + 1) * progressStep;
      threshold.element.addClass("discount-bar__threshold--filled");
      if (threshold.isDiscount) { highestDiscountUnlocked = threshold.text; }
      else freeShippingUnlocked = true;
    } else if (totalPrice > prevValue) {
      const range = threshold.value - prevValue;
      fillPercentage = (index * progressStep) + ((totalPrice - prevValue) / range) * progressStep;
      if (!nextThreshold) nextThreshold = threshold;
    } else if (!nextThreshold) nextThreshold = threshold;
  });

  $progressFill.css("width", `${fillPercentage}%`);

  // Update status message
  let message = "";
  if (freeShippingUnlocked) message = "Congratulations! You’ve unlocked FREE shipping!";
  if (highestDiscountUnlocked) message += message ? " & " : "" + highestDiscountUnlocked;
  if (nextThreshold) {
    const remaining = ((nextThreshold.value - totalPrice) * 0.01).toFixed(2);
    log.collapse({
      'nextThreshold': nextThreshold,
      'nextThresholdText': nextThreshold.text,
      'nextThresholdValue': nextThreshold.value,
      'totalPrice': totalPrice,
      'nextThresholdValue - totalPrice': nextThreshold.value - totalPrice,
      'remaining': remaining,
      'currency': currency
    }, 'REMAINING');
    const currency_symbol = $('<div>').html(currency).text();
    const thresholdText = nextThreshold.text.replace(/free/i, 'FREE');
    message += message ? ". " : "" + `You're ${currency_symbol + remaining} away from ${thresholdText}.`;
  }

  $statusMessageElement.text(message);
}


$(document).on("click", ".cb_atc_btn", function (e) {
  e.preventDefault();
  postToCart({ id: $(this).data('id'), quantity: 1 }, () => {
    buildCart();
    $('.KD_cart_drawer_outer').css('display', 'flex').delay(100).addClass('active');
  });
});


$(document).on("click", ".KD_cart_story_upsells", function () {
  const checkbox = $(this).find('.KD_cart_story_checkbox').toggleClass('active');
  if (checkbox.hasClass('active')) {
    $.post("/cart/add.js", { id: $(this).data('id'), quantity: 1 }, buildCart, "json")
      .fail(() => console.error("Failed to add upsell"));
  }
});

$(document).on("click", ".KD_cart_upsells_close", function () {
  $('.KD_cart_upsells_single.KD_cart_upsells_out').toggleClass('active');
});




$(document).on("click", ".phone_desk_only, .header__icon--cart, .kd-cart-drawer", function (e) {
  e.preventDefault();
  log(" ======================================= \n Opening Cart \n =======================================")
  openSlideCart();
});

$('.KD_cart_goback').click(closeSlideCart);
$('.KD_cart_drawer_outer').click(function () {
  if (!$(event.target).closest('.KD_cart_drawer').length) {
    closeSlideCart();
  }
});

function openSlideCart() {
  $('.KD_cart_drawer_outer').css('display', 'flex');
  setTimeout(function () {
    $("body").addClass("Overflow_hidden overflow-hidden");
    $('.KD_cart_drawer_outer').addClass('active');
    $('.KD_cart_upsells_carousel').slick('refresh');
    setTimeout(() => $('.KD_cart_upsells_out').addClass('active'), 300);
  }, 100);
}

function closeSlideCart() {
  $('.KD_cart_drawer_outer').removeClass('active');
  setTimeout(function () {
    $('.KD_cart_drawer_outer').hide();
    $("body").removeClass("Overflow_hidden overflow-hidden");
  }, 300);
}
window.cart_open = openSlideCart;
window.cart_close = closeSlideCart;
window.cart_build = buildCart;